import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SectionHeader } from "@/components/site/Reveal";
import { PORTFOLIO } from "@/data";

const Card = ({ item, lang, labels, i }) => (
  <motion.div
    data-testid={`portfolio-item-${item.id}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
    className="group relative overflow-hidden rounded-2xl border border-white/10 h-[340px] sm:h-[400px] cursor-pointer"
  >
    {/* AFTER (base) */}
    <img src={item.after} alt={item[lang]} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
    {/* BEFORE (revealed on hover) */}
    <img
      src={item.before}
      alt={`${item[lang]} before`}
      className="absolute inset-0 h-full w-full object-cover opacity-100 group-hover:opacity-0 transition-opacity duration-500"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-transparent to-transparent" />

    <span className="absolute top-4 left-4 z-10 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide bg-white/15 backdrop-blur-sm text-white group-hover:hidden">
      {labels.before}
    </span>
    <span className="absolute top-4 left-4 z-10 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide bg-[#E85D04] text-white hidden group-hover:inline-block">
      {labels.after}
    </span>

    <div className="absolute bottom-5 left-5 right-5 z-10">
      <h3 className="font-display font-bold text-xl text-white">{item[lang]}</h3>
    </div>
  </motion.div>
);

export const Portfolio = () => {
  const { t, lang } = useLang();
  return (
    <section id="portfolio" className="py-24 sm:py-32 bg-[#111827] relative noise-overlay" data-testid="portfolio-section">
      <div className="container-x">
        <SectionHeader tag={t.portfolio.tag} title={t.portfolio.title} subtitle={t.portfolio.subtitle} />
        <div className="grid sm:grid-cols-2 gap-5 mt-14">
          {PORTFOLIO.map((item, i) => (
            <Card key={item.id} item={item} lang={lang} labels={t.portfolio} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
